import { readableSegmentType } from '~/lib/segments';

import styles from './styles';
import WarningIcon from './warning.svg';

const Notice = ({ classes, destinationType, segmentType }) => {
  switch (destinationType) {
    case 'salesforce':
      return (
        <div className={classes.salesforceNotice}>
          <WarningIcon className={classes.icon} />
          This destination will only be triggered for{' '}
          {readableSegmentType(segmentType)} with associated Salesforce records
        </div>
      );
    default:
      return null;
  }
};

export default withStyles(styles)(Notice);
